import { AdvantageItem } from '@features/landing/shared/ui/components/AdvantageItem/AdvantageItem';
import { HomeIcon } from '@features/landing/shared/ui/icons/advantages/HomeIcon';
import { TimeIcon } from '@features/landing/shared/ui/icons/advantages/TimeIcon';
import { StonksIcon } from '@features/landing/shared/ui/icons/advantages/StonksIcon';
import { WalletIcon } from '@features/landing/shared/ui/icons/advantages/WalletIcon';
import { PeopleIcon } from '@features/landing/shared/ui/icons/advantages/PeopleIcon';
import { ShieldIcon } from '@features/landing/shared/ui/icons/advantages/ShieldIcon';
import { AdvantagesSection } from '@features/landing/shared/ui/sections/AdvantagesSection';

export function SummerAdvantagesSection() {
  return (
    <AdvantagesSection
      title={<>Преимущества онлайн-турниров</>}
      leftItems={
        <>
          <AdvantageItem
            icon={<HomeIcon />}
            iconPosition="right"
            title="Механика проведения"
            description={
              <>
                Турниры проводятся онлайн, на платформе ChessOpen. Для игры
                понадобятся регистрация, подписка, компьютер или мобильное
                устройство и веб-камера, установленная по нашей схеме. Так все
                будут уверены, что играет именно ребенок, а не бот или родитель.
              </>
            }
          />

          <AdvantageItem
            icon={<StonksIcon />}
            iconPosition="left"
            title="История партий и разбор ошибок"
            description={
              <>
                Все сыгранные партии сохраняются в личном кабинете, где их можно
                разобрать и проанализировать с ИИ или тренером. Дети получают
                реальных соперников и возможность развивать свою игру вместе с
                ними.
              </>
            }
          />

          <AdvantageItem
            icon={<PeopleIcon />}
            iconPosition="right"
            title="Соперники"
            description={
              <>
                В отличие от других сайтов, игра на рейтинг ФШР — это реальные
                соперники с настоящими именами, подтвержденным уровнем игры, из
                подходящей рейтинговой группы, а не ноунеймы с бесплатными
                аккаунтами или боты на стокфише.
              </>
            }
          />
        </>
      }
      rightItems={
        <>
          <AdvantageItem
            icon={<TimeIcon />}
            iconPosition="right"
            title="Экономия времени"
            description={
              <>
                Онлайн-турнир по блицу занимает 2 часа, по рапиду — 3,5 часа.
                Больше не нужно тратить целый выходной на то, чтобы доехать до
                места проведения турнира, а потом сидеть в шумном помещении 6
                часов подряд, ожидая, пока судьи разберутся с чужими проблемами.
              </>
            }
          />

          <AdvantageItem
            icon={<WalletIcon />}
            iconPosition="left"
            title="Экономия денег"
            description={
              <>
                Взносы на офлайн турнирах от 1500 до 5500 (в среднем 3000 ₽) +
                расходы на парковку, еду на фуд-корте ТЦ, делают участие в
                турнирах довольно дорогим удовольствием. У нас все иначе.
                Подписка на месяц турниров стоит как взнос в один офлайн турнир.
              </>
            }
          />

          <AdvantageItem
            icon={<ShieldIcon />}
            iconPosition="right"
            title="Анти-читинг"
            description={
              <>
                Игра проходит по видеосвязи, где камера снимает участника и его
                экран, исключая 95% самых распространенных способов читерства.
                При возникновении сомнений в действиях участника, отдел
                античитнга проверяет каждого игрока, статистику его выступлений
                против игроков из разных рейтинговых групп, сравнивает точность
                его ходов с программой (стокфиш) и определяет вероятность
                жульничества. Читерить у нас на турнирах сложнее, чем в офлайне.
              </>
            }
          />
        </>
      }
    />
  );
}
